/* ============
 * Reports Page
 * ============
 *
 * This is the page for reports.
 */
import moment from 'moment';
import helpers from './../../../../utils/helpers';
import Forms from "../../../../utils/forms/forms";
import organizationSettingsTransformer from './../../../../transformers/organizationSettings';
import organizationSettingsService from './../../../../services/organizationSettings';
import { mapGetters, mapMutations } from 'vuex';
import store from "../../../../store";
import Vue from "vue";
import DateMixin from './../../../../mixins/date';
import exportModal from './../../../../components/ExportHistory/ExportHistory.vue';
import billService from './../../../../services/bill';

export default {
  data() {
    return {
      archiveList:[],
      description: new Forms({
        description: {
          value: '',
          type: 'textarea',
        },
      }),
      selectedProvider: false,
      cliked: false,
      dialogVisible: false,
      dialogDisabled:false,
      salesData: [],
      selectedArchive: null,
      salesDateRange: [moment().subtract(1, 'months'), moment()],
      billsDateRange: [moment().subtract(1, 'months'), moment()],
    };
  },



  computed: {
    ...mapGetters({
      providerList: 'setDownloadProviderList',
      settings: 'organizationSettings',
    }),
    dataList(){
      return this.archiveList.map((c, index) => ({
        periode: this.formatDate(c.date_start)+ ' - '+this.formatDate(c.date_stop),
        description: c.description,
        provider: c.provider,
        download: this.$t('static.bills.exportBill.download.download'),
        id: c.id,
        date_start: this.formatDate(c.date_start),
        date_stop: this.formatDate(c.date_stop),
      }));
    },
    buttons(){
      return [
        {
          class: 'btn mall el-button--danger',
          label: this.$t('button.delete'),
          click: this.deleteItem,
        },
      ];
    },
  },
  created(){
     var requests = [];
    if (Object.keys(this.settings).length === 0) {
      requests.push(organizationSettingsService.show());
    }

    requests.push(billService.archiveReport());
    this.loading = true;
    Promise.all(requests).then((data) => {
        this.loading = false;
    });
  },
  watch: {
    /**
     * Watches state of client groups and inject to Forms class.
     */
    providerList(providerList) {
      this.archiveList = providerList.downloadExportList;
      (this.archiveList.length) ? this.selectedProvider = true : this.selectedProvider = false;

    },
  },

    methods: {
      ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    onSalesFilterChange(name, value) {
      if ((name === 'billsDateRange' || name === 'salesDateRange') &&
        value === undefined) {
        this[name] = [moment().subtract(1, 'months'), moment()];
      } else {
        this[name] = value;
      }
    },
    /**
     * Create export provider list data.
     */
    CreateDownloadList () {
      const params = {};

      if (this.rowLimit > 0) {
        params.limit = this.rowLimit;
      }

      console.log(this.settings);
      if(this.settings.accountingProvider) {
        if (this.billsDateRange[0] && this.billsDateRange[1]) {
          params.token = localStorage.getItem('id_token');
          params.date_start = moment(this.billsDateRange[0]).format('YYYY-MM-DD');
          params.date_stop = moment(this.billsDateRange[1]).format('YYYY-MM-DD');
          params.provider = this.settings.accountingProvider.slug;
          params.description = this.description.description;

        }

        store.dispatch('setNewProviderItemList', params);
        this.selectedProvider = true;
        this.description.description = '';
        this.cliked = false;


        return new Promise((resolve, reject) => {
          Vue.$http.post('export-create-record', params);
        });
      }
      else {
        this.cliked = true;
      }
    },
    /**
     * Downloads the reports.
     */
    downloadBillReport(item) {

      const params = {};

      if (this.rowLimit > 0) {
        params.limit = this.rowLimit;
      }

      if (this.billsDateRange[0] && this.billsDateRange[1]) {
        params.date_start = item.date_start;
        params.date_stop = item.date_stop;
        params.provider = this.settings.accountingProvider.slug;
        params.description = item.description;
      }

      window.open(helpers.buildUrl(`${process.env.API_LOCATION}/export-download/`, {
        token: localStorage.getItem('id_token'),
        ...params,
      }));
    },

    deleteItem(scope){
      this.selectedArchive = scope;

      this.dialogVisible = true;
    },
    handleClose(){
      this.selectedArchive = null;
    },
    deleted(){
      let me = this;

      Vue.$http.delete('export-delete-record/'+me.selectedArchive.row.id).then(function(data){
         me.dataList.splice(me.selectedArchive.$index,1);
         me.dialogVisible = false;
      });
    },
     /**
     * Activates the modal
     */
    activateModalExport() {
      this.setModalContent(() => exportModal);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },
    showExportModal(){
        this.activateModalExport();
    },
  },

  components: {
    VDateRange: require('./../../../../components/form/dateRange/dateRange.vue'),
    VMessage: require('./../../../../components/form/message/message.vue'),
    VForm: require('./../../../../components/form/form.vue'),
    VTable: require('./../../../../components/table/table.vue'),
  },
  mixins: [
    DateMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/bills/export/export.js